<template>
  <div class="guest-management">
    <div class="filter-panel">
      <div class="search-container">
        <el-input placeholder="搜索嘉宾姓名、公司或职位" v-model="searchKeyword" class="search-input" size="small" @keyup.enter.native="handleSearch">
          <template v-slot:prefix>
            <i class="el-input__icon el-icon-search"></i>
          </template>
        </el-input>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search" size="small">搜索</el-button>
        
        <!-- 添加分类筛选下拉框 -->
        <el-select 
          v-model="selectedCategory" 
          placeholder="按分组筛选" 
          size="small" 
          class="category-filter"
          clearable
          @change="handleCategoryChange"
        >
          <el-option
            v-for="category in categoryOptions"
            :key="category._id"
            :label="category.name"
            :value="category._id"
          ></el-option>
        </el-select>
      </div>
      <div class="action-container">
        <el-button type="primary" @click="addGuest" icon="el-icon-plus" size="small">新增嘉宾</el-button>
        <el-button type="warning" @click="manageCategories" icon="el-icon-collection-tag" size="small">管理分组</el-button>
        <el-button type="danger" @click="batchDeleteConfirm" icon="el-icon-delete" size="small" :disabled="!selectedGuests.length">批量删除</el-button>
        <el-button type="success" @click="handleExport" icon="el-icon-download" size="small">导出嘉宾</el-button>
        <el-button type="warning" @click="handleImport" icon="el-icon-upload2" size="small">导入嘉宾</el-button>
      </div>
    </div>

    <div class="content" v-loading="loading">
      <div class="table-view">
        <!-- 添加统计信息和筛选指示 -->
        <div class="filter-info" v-if="guestList.length || selectedCategory">
          <span>
            共有 <span class="count-number">{{ pagination.total }}</span> 位嘉宾
            <template v-if="selectedCategory">
              <span class="filter-tip">
                (按分组 "<span class="category-name">{{ categoryMap[selectedCategory] }}</span>" 筛选)
              </span>
              <el-button type="text" size="mini" @click="clearCategoryFilter">
                <i class="el-icon-close"></i> 清除筛选
              </el-button>
            </template>
          </span>
        </div>

        <el-table 
          :data="guestList" 
          stripe 
          style="width: 100%" 
          @selection-change="handleSelectionChange"
          border
          highlight-current-row>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="avatar" label="头像" width="80" align="center" class-name="avatar-col">
            <template v-slot="scope">
              <div class="avatar-wrapper">
                <el-image
                  class="avatar-img"
                  :src="getAvatarUrl(scope.row)"
                  fit="cover"
                  :lazy="true"
                  @error="() => handleAvatarError(scope.row)"
                >
                  <div slot="placeholder" class="avatar-placeholder"></div>
                  <div slot="error" class="avatar-error"></div>
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="company" label="公司" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="position" label="职务" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="分组" width="120" align="center">
            <template v-slot="scope">
              <el-tag size="small" v-if="scope.row.categoryName">{{ scope.row.categoryName }}</el-tag>
              <span v-else class="no-group">未分组</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" width="160" align="center"></el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="small" @click="editGuest(scope.row._id)">
                <i class="el-icon-edit"></i> 编辑
              </el-button>
              <el-button type="text" size="small" @click="deleteGuestConfirm(scope.row._id)" class="delete-btn">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 添加空状态 -->
        <el-empty 
          v-if="!loading && guestList.length === 0" 
          description="未找到嘉宾数据"
          :image-size="200"
        >
          <template v-if="selectedCategory || searchKeyword">
            <p class="empty-description">
              可能是因为当前筛选条件导致没有匹配的结果
            </p>
            <div class="empty-actions">
              <el-button type="primary" @click="resetFilters" size="small">清除筛选条件</el-button>
            </div>
          </template>
          <template v-else>
            <el-button type="primary" @click="addGuest">添加嘉宾</el-button>
          </template>
        </el-empty>
      </div>

      <div class="card-view" v-if="false">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(guest, index) in guestList" :key="index">
            <el-card shadow="hover" class="guest-card">
              <div class="card-header">
                <el-avatar :size="60" :src="guest.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" 
                  fit="cover"></el-avatar>
                <div class="guest-info">
                  <h3>{{ guest.name }}</h3>
                  <p class="position">{{ guest.position }}</p>
                  <p class="company">{{ guest.company }}</p>
                </div>
              </div>
              <div class="card-info">
                <p class="card-company">{{ guest.company }}</p>
              </div>
              <div class="card-actions">  
                <el-button type="text" size="small" @click="editGuest(guest._id)">
                  <i class="el-icon-edit"></i> 编辑
                </el-button>
                <el-button type="text" size="small" @click="deleteGuestConfirm(guest._id)" class="delete-btn">
                  <i class="el-icon-delete"></i> 删除
                </el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="pagination-container">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <!-- 导出配置对话框 -->
    <el-dialog
      title="导出嘉宾"
      :visible.sync="exportDialogVisible"
      width="500px"
    >
      <el-form :model="exportConfig" label-width="100px">
        <el-form-item label="文件名">
          <el-input v-model="exportConfig.fileName" placeholder="请输入文件名"></el-input>
        </el-form-item>
        <el-form-item label="导出范围">
          <el-radio-group v-model="exportConfig.scope">
            <el-radio label="all">全部数据</el-radio>
            <el-radio label="filtered">当前筛选结果</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导出字段">
          <el-checkbox-group v-model="exportConfig.fields">
            <el-checkbox label="name" disabled>姓名</el-checkbox>
            <el-checkbox label="company">公司</el-checkbox>
            <el-checkbox label="position">职位</el-checkbox>
            <el-checkbox label="phone">手机号</el-checkbox>
            <el-checkbox label="email">邮箱</el-checkbox>
            <el-checkbox label="category">分组</el-checkbox>
            <el-checkbox label="bio">个人简介</el-checkbox>
            <el-checkbox label="avatar">头像</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmExport" :loading="exporting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog
      title="导入嘉宾"
      :visible.sync="importDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-steps :active="importStep" finish-status="success" simple style="margin-bottom: 20px">
        <el-step title="上传文件"></el-step>
        <el-step title="数据预览"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>

      <!-- 步骤1：上传文件 -->
      <div v-if="importStep === 0">
        <div class="import-tips">
          <p>1. 请先下载导入模板，按照模板格式填写数据</p>
          <p>2. 如需导入头像，请将图片文件打包成ZIP格式，图片名称需与Excel中的匹配字段对应</p>
          <el-button type="text" @click="downloadTemplate">下载导入模板</el-button>
        </div>
        
        <el-form label-width="100px" class="import-form">
          <el-form-item label="Excel文件">
            <el-upload
              class="excel-uploader"
              action="#"
              :auto-upload="false"
              :on-change="handleExcelChange"
              :file-list="excelFileList"
              accept=".xlsx,.xls"
            >
              <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传 xlsx/xls 文件</div>
            </el-upload>
          </el-form-item>
          
          <el-form-item label="头像文件">
            <el-upload
              class="zip-uploader"
              action="#"
              :auto-upload="false"
              :on-change="handleZipChange"
              :file-list="zipFileList"
              accept=".zip"
            >
              <el-button slot="trigger" size="small" type="primary">选择ZIP文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传 zip 格式的压缩包</div>
            </el-upload>
          </el-form-item>

          <el-form-item label="头像匹配" v-if="zipFileList.length">
            <el-select v-model="importConfig.avatarMatchField" placeholder="请选择匹配字段">
              <el-option label="姓名" value="name"></el-option>
              <el-option label="手机号" value="phone"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!-- 步骤2：数据预览 -->
      <div v-if="importStep === 1">
        <div class="preview-stats">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">总记录数</div>
                <div class="stat-value">{{ previewData.total }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item success">
                <div class="stat-label">有效记录</div>
                <div class="stat-value">{{ previewData.valid }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item error">
                <div class="stat-label">错误记录</div>
                <div class="stat-value">{{ previewData.invalid }}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="previewData.errors.length" class="error-list">
          <h4>错误详情：</h4>
          <el-table :data="previewData.errors" size="small" style="width: 100%">
            <el-table-column prop="row" label="行号" width="80"></el-table-column>
            <el-table-column label="错误信息">
              <template v-slot="scope">
                <div v-for="(error, index) in scope.row.errors" :key="index">
                  {{ error.field }}: {{ error.message }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 步骤3：导入结果 -->
      <div v-if="importStep === 2">
        <div class="import-result">
          <el-result
            :icon="importResult.success ? 'success' : 'error'"
            :title="importResult.success ? '导入成功' : '导入失败'"
            :subTitle="importResult.message"
          >
            <template v-if="importResult.success">
              <div class="result-stats">
                <p>成功导入：{{ importResult.data.success }} 条</p>
                <p>失败记录：{{ importResult.data.failed }} 条</p>
              </div>
            </template>
          </el-result>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelImport">{{ importStep === 2 ? '关闭' : '取消' }}</el-button>
        <el-button 
          v-if="importStep < 2" 
          type="primary" 
          @click="nextStep"
          :loading="importing"
          :disabled="!canProceed"
        >{{ importStep === 1 ? '开始导入' : '下一步' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
  getGuestList, 
  deleteGuest, 
  batchDeleteGuests, 
  getGuestCategories,
  exportGuests,
  getImportTemplate,
  validateImportData,
  processImportData,
  importGuests
} from "@/api/guest";
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import iconv from 'iconv-lite';

export default {
  data() {
    return {
      loading: true,
      guestList: [],
      searchKeyword: '',
      viewMode: 'table',
      selectedGuests: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      categoryMap: {}, // 用于存储分组ID到分组名称的映射
      selectedCategory: '', // 当前选中的分类
      categoryOptions: [], // 分类选项列表
      
      // 导出相关
      exportDialogVisible: false,
      exportConfig: {
        fileName: '',
        scope: 'all',
        fields: ['name', 'company', 'position'],
        format: 'xlsx'
      },
      exporting: false,

      // 导入相关
      importDialogVisible: false,
      importStep: 0,
      importConfig: {
        avatarMatchField: 'name'
      },
      excelFileList: [],
      zipFileList: [],
      previewData: {
        total: 0,
        valid: 0,
        invalid: 0,
        errors: [],
        validData: []
      },
      importing: false,
      importResult: {
        success: false,
        message: '',
        data: null
      }
    };
  },
  computed: {
    selectedIds() {
      return this.selectedGuests.map(guest => guest._id);
    },
    canProceed() {
      if (this.importStep === 0) {
        return this.excelFileList.length > 0;
      }
      if (this.importStep === 1) {
        return this.previewData.valid > 0;
      }
      return false;
    }
  },
  methods: {
    getAvatarUrl(row) {
      const src = row && row.avatar ? String(row.avatar).trim() : '';
      if (!src) return this.getDefaultAvatar();
      try {
        // 追加短期缓存破坏参数，避免部分浏览器/代理缓存导致的“卡住不显示”
        const url = new URL(src, window.location.origin);
        url.searchParams.set('_t', String(Math.floor(Date.now() / 60000))); // 每分钟变一次
        return url.toString();
      } catch (e) {
        return src;
      }
    },
    getDefaultAvatar() {
      return 'https://fankeymice.com/uploads/img/default-avatar.png';
    },
    handleAvatarError(row) {
      // 失败兜底：切换到默认头像
      if (row) row.avatar = this.getDefaultAvatar();
    },
    handleSearch() {
      this.pagination.page = 1;
      this.getGuestList();
    },
    async getGuestList() {
      this.loading = true;
      try {
        // 获取分组列表
        await this.fetchCategories();
        
        const param = { 
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          search: this.searchKeyword
        }
        
        // 添加分类筛选参数
        if (this.selectedCategory) {
          param.category = this.selectedCategory;
        }
        
        const response = await getGuestList(param);
        if (response.status === '10000') {
          // 处理嘉宾数据，添加分组名称
          this.guestList = response.data.map(guest => {
            const categoryId = guest.category;
            if (categoryId && this.categoryMap[categoryId]) {
              guest.categoryName = this.categoryMap[categoryId];
            }
            return guest;
          });
          
          this.pagination.total = response.pagination.total;
          this.pagination.page = response.pagination.page;
          this.pagination.pageSize = response.pagination.pageSize;
        } else {
          this.$message.error(response.message || '获取嘉宾列表失败');
        }
      } catch (error) {
        this.$message.error('获取嘉宾列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    async fetchCategories() {
      try {
        const response = await getGuestCategories();
        if (response.status === '10000') {
          const categories = response.data.categories || [];
          // 保存分类选项用于下拉选择
          this.categoryOptions = categories;
          
          // 创建分组ID到名称的映射
          this.categoryMap = {};
          categories.forEach(category => {
            this.categoryMap[category._id] = category.name;
          });
        }
      } catch (error) {
        console.error('获取分组列表失败:', error);
      }
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.getGuestList();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 1;
      this.getGuestList();
    },
    addGuest() {
      this.$router.push({ name: "guest-edit" });
    },
    editGuest(guestId) {
      this.$router.push({ name: "guest-edit", query: { guestId } });
    },
    manageCategories() {
      this.$router.push({ name: "guest-category" });
    },
    deleteGuestConfirm(guestId) {
      this.$confirm('确定要删除该嘉宾吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteGuest(guestId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    async deleteGuest(guestId) {
      try {
        const response = await deleteGuest(guestId);
        if (response.status === '10000') {
          this.$message.success('嘉宾已删除');
          this.getGuestList();
        } else {
          this.$message.error(response.message || '删除嘉宾失败');
        }
      } catch (error) {
        this.$message.error('删除嘉宾失败');
      }
    },
    handleSelectionChange(selection) {
      this.selectedGuests = selection;
    },
    batchDeleteConfirm() {
      if (this.selectedGuests.length === 0) {
        this.$message.warning('请至少选择一个嘉宾');
        return;
      }
      
      this.$confirm(`确定要删除所选的 ${this.selectedGuests.length} 位嘉宾吗?`, '批量删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchDelete();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消批量删除'
        });          
      });
    },
    async batchDelete() {
      try {
        const response = await batchDeleteGuests(this.selectedIds);
        if (response.status === '10000') {
          this.$message.success(`成功删除 ${response.deletedCount || this.selectedGuests.length} 位嘉宾`);
          this.getGuestList();
        } else {
          this.$message.error(response.message || '批量删除嘉宾失败');
        }
      } catch (error) {
        this.$message.error('批量删除嘉宾失败');
      }
    },
    handleCategoryChange() {
      // 当分类选择变化时，重置分页到第一页并重新加载数据
      this.pagination.page = 1;
      this.getGuestList();
    },
    clearCategoryFilter() {
      this.selectedCategory = '';
      this.getGuestList();
    },
    
    resetFilters() {
      this.searchKeyword = '';
      this.selectedCategory = '';
      this.getGuestList();
    },
    
    filterByCategory(categoryId) {
      // 如果已经选中了该分类，则清除筛选；否则选中该分类
      if (this.selectedCategory === categoryId) {
        this.selectedCategory = '';
      } else {
        this.selectedCategory = categoryId;
      }
      this.pagination.page = 1;
      this.getGuestList();
    },

    // 导出相关方法
    handleExport() {
      const now = new Date();
      const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
      this.exportConfig.fileName = `嘉宾数据_${timestamp}.xlsx`;
      this.exportDialogVisible = true;
    },

    async confirmExport() {
      this.exporting = true;
      try {
        // 准备导出参数
        const params = {
          ...this.exportConfig,
          filters: this.exportConfig.scope === 'filtered' ? {
            category: this.selectedCategory,
            keyword: this.searchKeyword
          } : null
        };

        // 调用导出接口
        const response = await exportGuests(params);
        if (response.status === '10000') {
          // 将后端英文字段转换为中文表头，保持与导入模板一致
          let keyToLabel = {};
          try {
            const tplRes = await getImportTemplate();
            if (tplRes.status === '10000' && Array.isArray(tplRes.data?.fields)) {
              keyToLabel = tplRes.data.fields.reduce((acc, f) => {
                acc[f.key] = f.label;
                return acc;
              }, {});
            }
          } catch (e) {
            // 忽略模板获取失败，使用英文表头兜底
          }

          const selectedFields = this.exportConfig.fields || [];
          const headersZh = selectedFields.map(f => keyToLabel[f] || f);
          const dataZh = (response.data || []).map(row => {
            const obj = {};
            selectedFields.forEach(f => {
              const zh = keyToLabel[f] || f;
              obj[zh] = row[f] == null ? '' : row[f];
            });
            return obj;
          });

          const ws = XLSX.utils.json_to_sheet(dataZh, { header: headersZh });
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
          XLSX.writeFile(wb, this.exportConfig.fileName);

          this.$message.success('导出成功');
          this.exportDialogVisible = false;
        } else {
          this.$message.error(response.message || '导出失败');
        }
      } catch (error) {
        this.$message.error('导出失败：' + error.message);
      } finally {
        this.exporting = false;
      }
    },

    // 导入相关方法
    handleImport() {
      this.resetImport();
      this.importDialogVisible = true;
    },

    resetImport() {
      this.importStep = 0;
      this.excelFileList = [];
      this.zipFileList = [];
      this.previewData = {
        total: 0,
        valid: 0,
        invalid: 0,
        errors: [],
        validData: []
      };
      this.importResult = {
        success: false,
        message: '',
        data: null
      };
    },

    async downloadTemplate() {
      try {
        const response = await getImportTemplate();
        if (response.status === '10000') {
          // 创建模板Excel文件
          const template = response.data.fields.reduce((acc, field) => {
            acc[field.label] = field.required ? '必填' : '';
            return acc;
          }, {});

          const ws = XLSX.utils.json_to_sheet([template]);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
          XLSX.writeFile(wb, '嘉宾导入模板.xlsx');
        } else {
          this.$message.error(response.message || '下载模板失败');
        }
      } catch (error) {
        this.$message.error('下载模板失败：' + error.message);
      }
    },

    handleExcelChange(file) {
      this.excelFileList = [file];
    },

    handleZipChange(file) {
      this.zipFileList = [file];
    },

    // 添加一个新的辅助方法用于检测和转换编码
    async detectAndDecodeFileName(bytes, isDirectory = false) {
      // 如果输入是字符串，转换为Buffer
      let buffer;
      if (typeof bytes === 'string') {
        // 创建一个新的buffer来存储原始字节
        buffer = Buffer.alloc(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
          buffer[i] = bytes.charCodeAt(i) & 0xff;
        }
      } else if (bytes instanceof Uint8Array) {
        buffer = Buffer.from(bytes);
      } else {
        buffer = Buffer.from(new Uint8Array(bytes));
      }

      // 记录原始字节
      const originalBytes = [...buffer].map(b => b.toString(16).padStart(2, '0')).join(' ');
      console.log('原始字节:', originalBytes);

      // 检查是否是无效的UTF-8字节（0xFD）
      const invalidUtf8 = buffer.every(byte => byte === 0xFD);
      if (invalidUtf8) {
        console.log('检测到无效的UTF-8字节，尝试获取原始文件名');
        if (isDirectory) {
          const file = this.zipFileList[0].raw;
          if (file && file.name) {
            const dirName = file.name.replace(/\.zip$/, '');
            console.log('从ZIP文件名获取目录名:', dirName);
            return dirName;
          }
        }
      }

      // 尝试不同的编码
      const encodings = ['gbk', 'gb18030', 'gb2312', 'utf8'];
      
      for (const encoding of encodings) {
        try {
          const decoded = iconv.decode(buffer, encoding);
          if (/[\u4e00-\u9fa5]/.test(decoded)) {
            console.log('成功解码文件名:', {
              encoding,
              decoded,
              hasChineseChars: true,
              isDirectory
            });
            return decoded;
          }
        } catch (e) {
          console.warn(`${encoding}解码失败:`, e);
        }
      }

      // 如果都失败了，返回一个默认值
      return isDirectory ? '头像' : '未命名.jpg';
    },

    // 添加一个新的方法来处理路径
    async decodePath(path) {
      const parts = path.split('/');
      const decodedParts = [];
      
      for (const part of parts) {
        if (part) {
          const decoded = await this.detectAndDecodeFileName(part, part.indexOf('.') === -1);
          decodedParts.push(decoded);
        }
      }
      
      return decodedParts.join('/');
    },

    async nextStep() {
      if (this.importStep === 0) {
        // 解析Excel文件
        try {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            // 验证数据
            const response = await validateImportData({ data: jsonData });
            if (response.status === '10000') {
              this.previewData = response.data;
              this.importStep = 1;
            } else {
              this.$message.error(response.message || '数据验证失败');
            }
          };
          reader.readAsArrayBuffer(this.excelFileList[0].raw);
        } catch (error) {
          this.$message.error('解析Excel文件失败：' + error.message);
        }
      } else if (this.importStep === 1) {
        this.importing = true;
        try {
          // 创建 FormData 对象
          const formData = new FormData();
          
          // 添加Excel数据
          formData.append('data', JSON.stringify(this.previewData.validData));
          
          // 如果有ZIP文件，处理并添加到FormData
          if (this.zipFileList.length) {
            try {
              // 读取ZIP文件
              const zipFile = this.zipFileList[0].raw;
              const zipArrayBuffer = await this.readFileAsArrayBuffer(zipFile);
              
              // 创建新的ZIP文件
              const newZip = new JSZip();
              
              // 先加载ZIP文件
              const zip = await JSZip.loadAsync(zipArrayBuffer);
              
              // 获取所有图片文件
              const imageFiles = [];
              zip.forEach((relativePath, file) => {
                if (!file.dir && /\.(jpg|jpeg|png|gif)$/i.test(relativePath)) {
                  imageFiles.push({ path: relativePath, file });
                }
              });

              console.log('找到的图片文件:', imageFiles.map(f => f.path));

              // 处理每个图片文件
              for (const { path, file } of imageFiles) {
                // 获取文件内容
                const content = await file.async('arraybuffer');
                
                // 使用Excel中的名称作为文件名
                const guestName = this.previewData.validData[0]?.name;
                if (!guestName) {
                  throw new Error('Excel中未找到嘉宾姓名');
                }

                // 获取文件扩展名
                const ext = path.split('.').pop().toLowerCase();
                const finalName = `${guestName}.${ext}`;
                
                console.log('处理图片文件:', {
                  originalPath: path,
                  finalName,
                  guestName
                });
                
                // 添加到新的ZIP文件
                newZip.file(finalName, content);
              }
              
              // 生成新的ZIP文件
              const newZipBlob = await newZip.generateAsync({
                type: 'blob',
                compression: 'DEFLATE',
                compressionOptions: {
                  level: 9
                }
              });
              
              // 创建新的File对象
              const newZipFile = new File([newZipBlob], 'avatars.zip', {
                type: 'application/zip'
              });
              
              // 添加到FormData
              formData.append('avatarZip', newZipFile);
              formData.append('avatarConfig', JSON.stringify({
                matchField: this.importConfig.avatarMatchField,
                uploadPath: '/uploads/guests'
              }));
            } catch (error) {
              console.error('处理ZIP文件失败:', error);
              this.$message.error('处理ZIP文件失败：' + error.message);
              this.importing = false;
              return;
            }
          }

          // 发送导入请求
          const response = await importGuests(formData);

          this.importResult = {
            success: response.status === '10000',
            message: response.message,
            data: response.data
          };
          
          if (response.status === '10000') {
            // 刷新列表
            this.getGuestList();
          }
          
          this.importStep = 2;
        } catch (error) {
          this.$message.error('导入失败：' + error.message);
        } finally {
          this.importing = false;
        }
      }
    },

    cancelImport() {
      if (this.importing) {
        return;
      }
      this.importDialogVisible = false;
      this.resetImport();
    },

    // 添加辅助方法：将文件读取为ArrayBuffer
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
      });
    }
  },
  mounted() {
    this.getGuestList();
  },
};
</script>

<style scoped>
.guest-management {
  background-color: #f5f7fa;
  min-height: 100%;
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 84px);
}

.filter-panel {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-container {
  display: flex;
  gap: 10px;
  align-items: center;
  flex: 1;
}

.search-input {
  max-width: 300px;
}

.category-filter {
  width: 180px;
}

.filter-info {
  margin-bottom: 15px;
  color: #606266;
  font-size: 14px;
}

.count-number {
  color: #409EFF;
  font-weight: bold;
}

.filter-tip {
  color: #909399;
  margin-left: 5px;
}

.category-name {
  color: #409EFF;
  font-weight: bold;
}

.action-container {
  display: flex;
  gap: 10px;
}

.content {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

/* 固定表格行高，避免图片加载影响行高 */
::v-deep .el-table__body tr {
  height: 56px;
}
::v-deep .el-table__body td {
  padding: 8px 0;
}
/* 限制头像列单元格布局 */
::v-deep td.avatar-col .cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.avatar-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f3f5;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder,
.avatar-error {
  width: 100%;
  height: 100%;
  background-color: #f2f3f5;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.guest-card {
  margin-bottom: 20px;
  height: 240px;
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.guest-info {
  margin-left: 15px;
}

.guest-info h3 {
  margin: 0 0 5px 0;
  font-size: 16px;
}

.position, .company {
  margin: 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}

.card-info {
  padding: 10px 0;
  flex-grow: 1;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
}

.delete-btn {
  color: #f56c6c;
}

.delete-btn:hover {
  color: #f78989;
}

.no-data-text {
  color: #909399;
  font-size: 12px;
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .filter-panel {
    flex-direction: column;
  }
  
  .search-container {
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  
  .search-input {
    max-width: 100%;
  }
}

.card-company {
  font-size: 14px;
  color: #606266;
  margin: 5px 0;
}

.no-group {
  color: #909399;
  font-size: 13px;
}

.category-tags-container {
  background-color: #fff;
  border-radius: 4px;
  padding: 15px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.tags-label {
  margin-right: 10px;
  color: #606266;
  flex-shrink: 0;
}

.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.category-tag {
  cursor: pointer;
  transition: all 0.3s;
}

.category-tag:hover {
  transform: translateY(-2px);
}

.empty-description {
  color: #909399;
  font-size: 14px;
  margin-top: 10px;
}

.empty-actions {
  margin-top: 15px;
}

.import-tips {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.import-tips p {
  margin: 5px 0;
  font-size: 14px;
  color: #606266;
}

.import-form {
  margin-top: 20px;
}

.preview-stats {
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.stat-item.success {
  background-color: #f0f9eb;
}

.stat-item.error {
  background-color: #fef0f0;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.error-list {
  margin-top: 20px;
}

.error-list h4 {
  margin-bottom: 10px;
  color: #f56c6c;
}

.result-stats {
  margin-top: 20px;
  text-align: center;
}

.result-stats p {
  margin: 5px 0;
  font-size: 14px;
  color: #606266;
}

.excel-uploader,
.zip-uploader {
  text-align: left;
}

.el-upload__tip {
  line-height: 1.2;
  padding-top: 5px;
  font-size: 12px;
}

/* Ensure upload file icons and list render fully */
::v-deep .import-form .el-form-item__content {
  overflow: visible;
}

.excel-uploader,
.zip-uploader {
  display: inline-block;
  max-width: 100%;
}

::v-deep .excel-uploader .el-upload,
::v-deep .zip-uploader .el-upload {
  vertical-align: top;
}

::v-deep .excel-uploader .el-upload-list,
::v-deep .zip-uploader .el-upload-list {
  margin-top: 8px;
}

::v-deep .excel-uploader .el-upload-list__item,
::v-deep .zip-uploader .el-upload-list__item {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  overflow: visible;
}

::v-deep .excel-uploader .el-upload-list__item .el-icon-document,
::v-deep .zip-uploader .el-upload-list__item .el-icon-document {
  font-size: 16px;
}
</style> 